//Components
import { createPortal } from "react-dom";
import React, { useState, useEffect, useRef } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form';
import { useParams, useNavigate } from 'react-router-dom';
import { Header } from '../common/Header/Header'
import QRCode from "react-qr-code";
import Badge from 'react-bootstrap/Badge';
import Spinner from 'react-bootstrap/Spinner';

//Utils
import { RenderIf } from '../../utils/RenderIf';
import Socket from '../../utils/Socket.config';
import { FormatDateTime } from '../../utils/FormatDate';

//PDF
import { PDFDownloadLink } from '@react-pdf/renderer';
import DocPdf from '../Pdf/DocPdf';
//Icons
import { BsCheckLg } from "react-icons/bs";
//API
import { OrdersFetchAPI } from '../../api/Orders';
import { BusinessFetchAPI } from '../../api/Business';
import { DgiFetchAPI } from '../../api/Dgi';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { AsapFetchAPI } from '../../api/Asap';
import { TookanFetchAPI } from '../../api/Tookan';

//img
import logo_sp from '../img/logos/logo.png';
import './cart.css';
import Swal from 'sweetalert2';

import HeaderMain from '../Home/Headers/HeaderMain';
import Loader from '../Home/Loader';
import LoginUser from '../Profile/LoginUser';
import ErrorAlert from '../Alerts/ErrorAlert';
import AlertSmall from '../Alerts/AlertSmall';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';

const OrderConfirmation = () => {
  const navigate = useNavigate();
  //State for show modal
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [formatVoucher, setformatVoucher] = useState("");
  const [modalShowVoucher, setmodalShowVoucher] = useState(false)
  const [loginrequired, setLoginRequired] = useState(false);
  const [modalUser, setModalUser] = React.useState(false);
  // Keep a persistent socket reference and a flag to avoid double-emits
  const socketRef = useRef(null);
  const emailedRef = useRef(false);

  //State client data
  const [clientData, setClientData] = useState(() => {
    if (localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != '') {
      return JSON.parse(localStorage.getItem('client'))
    } else {
      return null
    }
  })
  const [guestClient, setGuestClient] = useState(() => {
    if (localStorage.getItem('guestClient') != null && localStorage.getItem('guestClient') != undefined && localStorage.getItem('guestClient') != '') {
      return localStorage.getItem('guestClient')
    } else {
      return null
    }
  });
  //State order data 
  const { order_code } = useParams();

  const [business_code, setbusiness_code] = useState(() => {
    if (localStorage.getItem("business") != "" && localStorage.getItem("business") != undefined) {
      return JSON.parse(localStorage.getItem("business")).code
    }
  });
  const [branchoffice_id, setbranchoffice_id] = useState(() => {
    if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined) {
      return JSON.parse(localStorage.getItem("branchoffice")).id
    }
  });
  const [machine_code_table, setmachine_code_table] = useState(() => {
    if (localStorage.getItem("machine") != "" && localStorage.getItem("machine") != undefined) {
      return JSON.parse(localStorage.getItem("machine")).code
    }
  });

  const [addressNowLocation, setAddressNowLocation] = useState(() => {
    if (localStorage.getItem('addressNowLocation') != null && localStorage.getItem('addressNowLocation') != undefined && localStorage.getItem('addressNowLocation') != '') {
      return JSON.parse(localStorage.getItem('addressNowLocation'))
    } else {
      return null
    }
  });

  const [eventHandler, setEventHandler] = useState(0);
  const [orderData, setOrderData] = useState({
    createdAt: "2023-07-25T10:02:35.000+00:00",
    cufe: "0",
    dgi_qr: "0"

  });
  const [cardsItems, setCardItems] = useState([]);
  const [listOrderHistroy, setOrderHistory] = useState([]);
  const [businessData, setBusinessData] = useState({
    name: ''
  });
  const [branchOfficeData, setBranchofficeData] = useState({
    "ruc": "",
    "dv": "",
    "name": "",
    "ruc_type": "",
    "direction": "",
    "dgi_name": "",
  });
  const deliveryValue = orderData?.delivery?.value;
  const formattedDeliveryValue = typeof deliveryValue === 'number'
    ? deliveryValue.toFixed(2)
    : deliveryValue || "0.00";


  //Total taxes 
  const [totalTaxes, setTotalTaxes] = useState([
    { total_base: 0, tax: "0%", total_tax: 0 },
    { total_base: 0, tax: "7%", total_tax: 0 },
    { total_base: 0, tax: "10%", total_tax: 0 },
    { total_base: 0, tax: "15%", total_tax: 0 }
  ]);

  // Status map  ASAP
  const ASAP_STATUS_MAP = {
    0: { key: 'placed', label: 'Order Placed' },
    6: { key: 'confirmed', label: 'Order Confirmed' },
    7: { key: 'dispatched', label: 'Order Dispatched' },
    2: { key: 'completed', label: 'Order Completed' },
    1: { key: 'cancelled', label: 'Order Cancelled' },
    100: { key: 'driver_arrived', label: 'Driver Arrived' },
    101: { key: 'driver_started', label: 'Driver Started' },
  };

  // Tookan: status map (basado en job_status)
  const TOOKAN_STATUS_MAP = {
    0: { key: 'placed', label: 'Task Created' },
    1: { key: 'assigned', label: 'Assigned' },    // algunas cuentas usan 1
    10: { key: 'assigned', label: 'Assigned' },    // otras 10
    6: { key: 'arrived', label: 'Driver Arrived' },
    2: { key: 'started', label: 'Picked Up' },
    3: { key: 'completed', label: 'Completed' },
    4: { key: 'failed', label: 'Failed' },
    9: { key: 'cancelled', label: 'Cancelled' },
    11: { key: 'in_progress', label: 'In Progress' }
  };

  // Flow para cada plataforma
  const ASAP_FLOW = ['placed', 'confirmed', 'dispatched', 'completed'];
  const TOOKAN_FLOW = ['placed', 'assigned', 'arrived', 'started', 'completed'];

  // Decide platform (se recalcula en cada render según orderData)
  const PLATFORM = (orderData?.delivery?.platform || '').toLowerCase();
  const STATUS_MAP = PLATFORM === 'tookan' ? TOOKAN_STATUS_MAP : ASAP_STATUS_MAP;
  const FLOW = PLATFORM === 'tookan' ? TOOKAN_FLOW : ASAP_FLOW;

  // UI state Tracking
  const [trackOpen, setTrackOpen] = useState(false);
  const [trackLoading, setTrackLoading] = useState(false);
  const [trackLog, setTrackLog] = useState([]);
  const [tookanTrackingLink, setTookanTrackingLink] = useState(null);
  const pollRef = useRef(null);

  // Derivados (usando el normalizador unificado)
  const latestEvent = trackLog?.[0] || null; // log en DESC
  const latestStatusCode = latestEvent?.code ?? null;
  const latestKey = STATUS_MAP[latestStatusCode]?.key ?? null;
  const isTerminal = latestKey === 'completed' || latestKey === 'cancelled' || latestKey === 'failed';
  const currentStepIndex = (() => {
    if (!latestKey) return -1;
    const idx = FLOW.indexOf(latestKey);
    return idx >= 0 ? idx : -1;
  })();

  // 1) Helper: mapea label_description/description a un status code Tookan
  const mapTookanLabelToCode = (textRaw) => {
    if (!textRaw) return null;
    const text = textRaw.replace(/<[^>]+>/g, '').toUpperCase(); // strip HTML + normalize

    // Orden importa: de más específico a más general
    if (/\b(COMPLETED|SUCCESS|TASK\s+COMPLETED)\b/.test(text)) return 3;           // completed
    if (/\b(PICKED|PICK\s?UP|STARTED|TASK\s+STARTED)\b/.test(text)) return 2;      // started/picked up
    if (/\b(ARRIVED|REACHED|AT\s+PICKUP|AT\s+DELIVERY|TASK\s+ARRIVED)\b/.test(text)) return 6; // arrived
    if (/\b(ASSIGNED|ACCEPTED|ACKNOWLEDGED|AUTO[-\s]?ASSIGNED)\b/.test(text)) return 10; // assigned
    if (/\b(EN[\s-]?ROUTE|ENROUTE|ON\s+THE\s+WAY)\b/.test(text)) return 11;        // in progress
    if (/\b(CANCEL|CANCELLED|UNASSIGNED)\b/.test(text)) return 9;                  // cancelled/unassigned
    if (/\b(FAILED|FAIL)\b/.test(text)) return 4;                                   // failed
    if (/\b(CREATED|NEW|TASK\s+CREATED|BY\s+API)\b/.test(text)) return 0;          // created/placed
    return null; // sin match
  };

  // Normaliza eventos para UI
  const normalizeEvent = (e) => {
    if (PLATFORM === 'tookan') {
      const ts =
        e?.creation_datetime ||
        e?.datetime ||
        e?.logged_at ||
        e?.created_at ||
        e?.date ||
        e?.timestamp ||
        null;

      // armamos un texto base para mapear
      const labelDesc = e?.label_description || e?.description || e?.activity || '';
      let code = mapTookanLabelToCode(labelDesc);

      const label =
        (e?.label_description?.replace(/<[^>]+>/g, '') ||
          e?.description ||
          e?.activity ||
          'Status');

      const description = e?.description || '';

      return {
        id: e?.id || `${code ?? 'x'}-${ts}-${Math.random().toString(36).slice(2)}`,
        code,          // puede quedar null; luego haremos fallback con job_status
        label,
        description,
        at: ts
      };
    }

    // ASAP (igual que ya lo tenías)
    const code = e?.delivery_status ?? e?.status ?? null;
    const ts = e?.logged_at || e?.created_at || e?.date || e?.timestamp || null;
    return {
      id: e?.id || `${code}-${ts}-${Math.random().toString(36).slice(2)}`,
      code,
      label: ASAP_STATUS_MAP[code]?.label || (e?.title ?? `Status ${code}`),
      description: e?.description || e?.message || '',
      at: ts,
    };
  };


  //Function to get order data 
  const getOrderByCode = async (code, branchoffice_id) => {
    try {
      const response = await OrdersFetchAPI.getOrderByCode(code, true, branchoffice_id);

      //console.log(response);
      return response;


    } catch (err) {
      //console.log(err);
    }
  }

  // function convert format voucher
  const formatVoucherString = () => {
    let voucher = orderData.voucher_response
    // Extraer el número de tarjeta ocultando los dígitos intermedios
    const maskedVoucher = voucher.replace(/(\d{6})\d+(\d{4})/g, "$1XXXXXX$2");

    // Construir el string formateado del voucher
    const formattedVoucher = `${maskedVoucher}`;
    setformatVoucher(formattedVoucher)
    //return formattedVoucher;
  };

  const handleViewCoucher = () => {
    formatVoucherString()
    setmodalShowVoucher(true)
  }

  //update order with client id
  const updateOrderWithClient = async (order) => {
    if (order._id) {
      try {
        const response = await OrdersFetchAPI.updateOrderStatus(undefined, order._id, undefined, undefined, { client: { client_id: clientData.id } });
        AlertSmall("Se ha guardado la transaccion en tu historico", "success");
        localStorage.removeItem('lastorderguest');
      } catch (err) {
        //console.log(err);
      }
    }
  }

  //We get the page data 
  useEffect(() => {
    (async () => {
      if (localStorage.getItem('lastorderguest') != undefined && localStorage.getItem('lastorderguest') != '' && localStorage.getItem('lastorderguest') != null && localStorage.getItem('guestClient') === "0") {
        updateOrderWithClient(JSON.parse(localStorage.getItem('lastorderguest')));
      }

      try {
        const response = await getOrderByCode(order_code, branchoffice_id);
        //console.log(response);
        if (localStorage.getItem('guestClient') !== null && localStorage.getItem('guestClient') !== undefined && localStorage.getItem('guestClient') !== 0 && localStorage.getItem('guestClient') !== "0") {
          localStorage.setItem('lastorderguest', JSON.stringify(response.data.order));
        }
        setOrderData(response.data.order);
        setCardItems(response.data.order.groups);
        setOrderHistory(response.data.order.status_update_history);
        //We get the business
        const response_business = await BusinessFetchAPI.getBusinessByCode(response.data.order.business.code)
        //We set the business data 
        setBusinessData(response_business.data.business)
        //We get the branchoffice info 
        const response_branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(response.data.order.business.code, response.data.order.branchoffice.code);
        //We set the business data 
        setBranchofficeData(response_branch.data.branchoffice);
        try {
          //We get the dgi info 
          const dgi_info_branch = await DgiFetchAPI.checkDGIContribuyent(response_branch.data.branchoffice.ruc);
          //console.log(dgi_info_branch)
          //setBranchofficeData( {dgi_name: dgi_info_branch.data.dgi_response.dNomb}, ...branchOfficeData)
        } catch (err) {
          //console.log(err)
        }

      } catch (err) {
        //console.log(err)
      }



    })()
  }, []);

  // Socket connection and events
  useEffect(() => {
    //Connection with the sockets server 
    socketRef.current = Socket({ branchoffice_id, order_code });

    //We update the estate of the order depending of the signal of the order 
    socketRef.current.on(`branchoffice_${branchoffice_id}_orderUpdated_${order_code}`, (updatedOrder) => {
      //console.log(updatedOrder)
      //We set orders history 
      setOrderHistory(updatedOrder.status_update_history);
      //We refresh
      setEventHandler(1)
    });

    // Listen for email notify result (optional UX/log)
    socketRef.current.on('orderEmailNotifyResult', (res) => {
      //console.log('[socket] orderEmailNotifyResult', res);
      // You can show a toast if you want:
      // if (res.success) Swal.fire({ toast:true, icon:'success', title:'Correo de orden enviado', timer:2000, showConfirmButton:false });
      // else if (res.duplicate || res.skipped) console.info('Email already handled/skipped');
      // else console.error('Email send error:', res.error);
    });

    // When the component is over, we  disconect the client of the socket 
    return () => {
      // Clean up
      try { socketRef.current?.off('orderEmailNotifyResult'); } catch { }
      try { socketRef.current?.disconnect(); } catch { }
      socketRef.current = null;
    };
  }, [order_code])

  // Emit the orderEmailNotify event once per page load after data is ready
  useEffect(() => {
    //console.log(orderData);
    // Guard conditions
    if (!socketRef.current) return;
    if (emailedRef.current) return; // prevent double emit
    if (!orderData || !orderData.transaction_code) return;
    if (!business_code || !machine_code_table) return;

    // Prefer branch office code from the order; fallback as needed
    const branchoffice_id =
      orderData?.branchoffice?.id ||
      branchOfficeData?.id || // if your API returns it here
      null;

    if (!branchoffice_id) return;

    // Build payload — server handler will fetch the order by display_id
    const payload = {
      business_code,
      branchoffice_id,
      machine_code: machine_code_table,
      // Priority: the email typed in the checkout contact form (saved on the order), then the logged client's, then the address'
      client_email: orderData?.client_email || (clientData?.email && clientData.email !== "invitado@invitado.com" ? clientData.email : addressNowLocation?.email || null),
      order_code: order_code, // this is your route param; equals display_id in your API
      // force: true, // (optional) only for admin/manual retries
    };


    //console.log('[socket] Emitting orderEmailNotify with payload', payload);

    //console.log('[socket] Emitting orderEmailNotify', payload);
    socketRef.current.emit('orderEmailNotify', payload);
    emailedRef.current = true; // mark as sent (frontend-side)
  }, [
    orderData?.transaction_code,
    order_code,
    business_code,
    machine_code_table,
    orderData?.branchoffice?.code,
    branchOfficeData?.code
  ]);


  useEffect(() => {
    //We set orders history 
    setOrderHistory(listOrderHistroy);
    setEventHandler(0)
  }, [eventHandler])

  // Fetch delivery log
  const fetchDeliveryLogOnly = async () => {
    try {
      setTrackLoading(true);

      // external id esperado por tus APIs
      const externalOrderId = orderData?.delivery?.order_id || null;

      if (orderData?.delivery?.platform === "asap") {
        const res = await AsapFetchAPI.getAsapOrderLogStatus(
          undefined,
          branchoffice_id,
          externalOrderId
        );
        const raw = Array.isArray(res?.data?.delivery_log?.delivery_log)
          ? res.data.delivery_log.delivery_log
          : [];

        const ordered = [...raw].sort((a, b) =>
          new Date(b.logged_at || b.created_at || b.date || b.timestamp) -
          new Date(a.logged_at || a.created_at || a.date || a.timestamp)
        ).map(normalizeEvent);

        setTrackLog(ordered);
      } else if (orderData?.delivery?.platform === "tookan") {
        // Asegúrate que externalOrderId sea el job_id real
        const res = await TookanFetchAPI.getTookanOrderDetails(
          undefined,
          orderData.business.id,
          externalOrderId
        );
        // res.data = { message, status, data:[{...job...}] }
        const job = Array.isArray(res?.data?.raw.data) ? res.data.raw.data[0] : null;
        if (!job) {
          setTrackLog([]);
          setTookanTrackingLink(null);
          return;
        }

        setTookanTrackingLink(job?.tracking_link || null);

        const history = Array.isArray(job.task_history) ? job.task_history : [];
        const ordered = [...history].sort((a, b) =>
          new Date(b?.creation_datetime || 0) - new Date(a?.creation_datetime || 0)
        ).map(normalizeEvent);

        if (!ordered.length) {
          ordered.push(normalizeEvent({
            label_description: 'CREATED',
            creation_datetime: job.creation_datetime
          }));
        }

        // Fallback: si el último evento no tiene code, usamos job_status
        const latest = ordered[0];
        const codeFromJob = Number(job?.job_status);
        if (latest && (latest.code === null || latest.code === undefined) && !Number.isNaN(codeFromJob)) {
          latest.code = codeFromJob;
        }

        setTrackLog(ordered);
      }
    } catch (err) {
      console.error('fetchDeliveryLogOnly error', err);
    } finally {
      setTrackLoading(false);
    }
  };

  // Open/close + polling
  const openTracking = async () => {
    setTrackOpen(true);
    await fetchDeliveryLogOnly();

    if (!pollRef.current) {
      pollRef.current = setInterval(async () => {
        await fetchDeliveryLogOnly();
      }, 12000);
    }
  };

  const closeTracking = () => {
    setTrackOpen(false);
    if (pollRef.current) {
      clearInterval(pollRef.current);
      pollRef.current = null;
    }
  };

  // Stop polling on terminal
  useEffect(() => {
    if (isTerminal && pollRef.current) {
      clearInterval(pollRef.current);
      pollRef.current = null;
    }
  }, [isTerminal]);



  //We charge the items of the order
  const orderItems = () => {
    let items = cardsItems.map((options) => (
      <div className="ocf-item" key={options._id}>
        <div className="ocf-item-row">
          <img
            className="ocf-item-thumb"
            src={buildCloudinaryImageUrl({ url: options.img, width: 300, quality: "auto", type: "image" }) || undefined}
            width="44"
            height="44"
            alt=""
            loading="lazy"
          />

          <div className="ocf-item-body">
            <div className="ocf-item-top">
              {/* Name */}
              <span className="ocf-item-name">{options.name}</span>
              {/* Cantidad/ Quantity*/}
              <div className="ocf-item-amount">
                <span className="ocf-item-qty">x{options.amount}</span>
                <span className="ocf-item-price">${options.price.toFixed(2)}</span>
              </div>
            </div>

            {/** Segment items */}
            <div className="ocf-item-meta">
              <div className="ocf-item-line">
                {/* Name */}
                <span>Descuento</span>
                {/* Cantidad/ Quantity*/}
                <span className={options.discount === undefined ? "ocf-muted" : "ocf-item-discount"}>
                  {options.discount === undefined ? "No registrado" : "- $" + options.discount.toFixed(2)}
                </span>
              </div>

              {options.segments.length > 0 ? (
                <ul className="ocf-item-segments">
                  {options.segments.map((segments, segIndex) => (
                    <li key={`${options._id}-seg-${segIndex}`}>
                      {/* item name */}
                      {segments.item.name}
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          </div>
        </div>

        {options.note && options.note !== "" ? <>
          <div className="ocf-item-note">
            {/* Name */}
            <span className="ocf-item-note-label"><i className="uil uil-comment-notes" aria-hidden="true"></i> Nota</span>
            <p className="ocf-item-note-text">{options.note}</p>
          </div></> : <></>}

        {options.type === "reservable" && options.reservation_code && options.reservation_code !== "" ? <>
          <div className="ocf-item-qr">
            <span className="ocf-item-qr-label">Código QR</span>
            <div className="ocf-item-qr-box">
              <QRCode value={options.reservation_code}
                size={150}
                bgColor="#ffffff" // Color de fondo
                fgColor="#000000" // Color del texto
                level="H" />
            </div>
          </div></> : <></>}
      </div>
    ))
    return <> {items}</>
  }

  //We charge the history update
  const orderHistory = () => {
    let key_id = 0;
    let history = listOrderHistroy.map((history) => (
      <li key={key_id++} className="ocf-tl-item">
        <span className="ocf-tl-icon" aria-hidden="true">
          <BsCheckLg />
        </span>

        <div className="ocf-tl-body">
          <div className="ocf-tl-head">
            <h3 className="ocf-tl-status">{history.status}</h3>
            <time className="ocf-tl-date">{history.update_date}</time>
          </div>
          <p className="ocf-tl-text">
            {
              history.state && history.state === 1 ? 'Su orden ha sido confirmada para ser preparada' :
                history.state && history.state === 2 ? 'Su orden esta en preparación' :
                  history.state && history.state === 3 ? 'Su orden esta lista para ser entregada' :
                    'Su orden ya fue entregada'
            }
          </p>
        </div>
      </li>
    ));
    return <>{history}</>
  }


  const closedModalLoginAndRegister = () => {
    setClientData(JSON.parse(localStorage.getItem('client')))
    setLoginRequired(false);
  }





  const [loading, setLoading] = useState(true);
  const paymentInfo = orderData?.payment_info || {};



  /* ─────────────────────────────────────────────────────────────
     2) DENTRO DEL COMPONENTE — junto a tus otros useState
     ───────────────────────────────────────────────────────────── */

  // Dock móvil: qué hoja inferior está abierta ("status" | "total" | null)
  const [ocfSheet, setOcfSheet] = useState(null);

  // Último estado registrado de la orden (para el botón del dock)
  const ocfLastStatus = listOrderHistroy && listOrderHistroy.length > 0
    ? listOrderHistroy[listOrderHistroy.length - 1].status
    : "";

  // Mientras la hoja está abierta: bloquea el scroll del fondo y cierra con Escape
  useEffect(() => {
    if (!ocfSheet) return;
    const onKey = (e) => { if (e.key === "Escape") setOcfSheet(null); };
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKey);
    };
  }, [ocfSheet]);


  /* ─────────────────────────────────────────────────────────────
     3) FUNCIÓN DE TOTALES — junto a orderItems / orderHistory.
     Es el mismo bloque de totales del recibo, para usarlo en el
     recibo y en la hoja "Total" sin duplicarlo.
     ───────────────────────────────────────────────────────────── */

  const orderTotals = () => (
    <dl className="ocf-totals">
      <div className="ocf-total-row">
        <dt>Descuento</dt>
        <dd className="ocf-discount">
          - ${typeof orderData.subtotal === 'number' ? orderData.discount.toFixed(2) : orderData.discount}
        </dd>
      </div>
      <div className="ocf-total-row">
        <dt>Subtotal</dt>
        <dd>${typeof orderData.subtotal === 'number' ? orderData.subtotal.toFixed(2) : orderData.subtotal}</dd>
      </div>
      <RenderIf isTrue={orderData.delivery !== undefined && orderData.delivery !== null}>
        <div className="ocf-total-row">
          <dt>Delivery</dt>
          <dd>${formattedDeliveryValue}</dd>
        </div>
      </RenderIf>
      <div className="ocf-total-row">
        <dt>ITBMS</dt>
        <dd>${typeof orderData.tax === 'number' ? orderData.tax.toFixed(2) : orderData.tax}</dd>
      </div>
      <div className="ocf-total-row ocf-total-final">
        <dt>Total</dt>
        <dd>${typeof orderData.total === 'number' ? orderData.total.toFixed(2) : orderData.total}</dd>
      </div>
    </dl>
  );
  return (
    <>
      {loading && <Loader onFinish={() => setLoading(false)} />}
      {!loading &&
        (<>

          <div className="ecommerce-wrapper ocf-page">
            <HeaderMain />

            {/* ── ENCABEZADO ── */}
            <div className="ocf-wrap">
              <header className="ocf-head">
                <div className="ocf-head-title">
                  <h1 className="ocf-title">Orden</h1>
                  <p className="ocf-title-sub">#{orderData.transaction_code}</p>
                </div>

                <div className="ocf-head-actions">
                  <PDFDownloadLink className='pdf-viewer-sp ocf-btn ocf-btn-primary' document={<DocPdf
                    doc_type={orderData.invoice_type === "devolution" ? "credit_note" : "invoice"} invoiceQR={orderData.dgi_qr} invoiceDate={orderData.createdAt} cufe={orderData.cufe} auth_protocol={orderData.auth_protocol ? orderData.auth_protocol : "00000000"}
                    receptor={{
                      name: orderData.client_name,
                      ruc: orderData.client_ruc,
                      direction: "Panama",
                      dv: orderData.client_dv,
                    }}
                    emitter={branchOfficeData}
                    products={cardsItems} invoiceSubtotal={orderData.subtotal} totalTaxes={totalTaxes}
                    totalCashReceived={orderData.total} invoiceTotal={orderData.total} invoiceTotalItbms={orderData.tax} paymentMethod={orderData.paymenthod}


                  />} >
                    <i className="uil uil-file-download-alt" aria-hidden="true"></i>
                    <span>{orderData.invoice_type === "devolution" ? "Descargar nota de crédito" : "Descargar factura electrónica"}</span>
                  </PDFDownloadLink>

                  <RenderIf isTrue={orderData.delivery && orderData.delivery.platform !== "smartpay" && orderData.delivery.order_id && orderData.delivery.order_id !== ""}>
                    <button type="button" className="ocf-btn ocf-btn-ghost" onClick={openTracking}>
                      <i className="uil uil-truck" aria-hidden="true"></i> Seguimiento de delivery
                    </button>
                  </RenderIf>
                </div>
              </header>
            </div>

            {loginrequired == false ? <>
              <div className='ocf-wrap'>

                {/* Modal Table numb */}
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>Número de mesa </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <Row className="justify-content-md-center">
                        <Col md="auto">
                          <Form.Control className='w-100' placeholder="Ingrese el Número" />
                        </Col>
                      </Row>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="outline-secondary" onClick={handleClose}>
                      Cerrar
                    </Button>
                    <Button variant="success" onClick={handleClose}>
                      Guardar
                    </Button>
                  </Modal.Footer>
                </Modal>

                <div className="ocf-stack">

                  {/* ── REGISTRO (invitado) ── */}
                  {guestClient !== 0 && guestClient !== "0" ? (
                    <button type="button" className="ocf-banner" onClick={() => setLoginRequired(true)}>
                      <span className="ocf-banner-icon" aria-hidden="true"><i className="uil uil-user-plus"></i></span>
                      <span className="ocf-banner-text">
                        <strong>Crea tu cuenta</strong>
                        <span>Para una mejor experiencia regístrate aquí.</span>
                      </span>
                      <i className="uil uil-angle-right ocf-banner-chev" aria-hidden="true"></i>
                    </button>
                  ) : <></>}

                  {/** Payment info */}
                  <RenderIf isTrue={orderData.paymenthod_id === 23 && !!orderData?.payment_info}>
                    <section className="ocf-card ocf-info">
                      <div className="ocf-info-head">
                        <span className="ocf-info-icon" aria-hidden="true"><i className="uil uil-university"></i></span>
                        <h2 className="ocf-h2">Datos bancarios para transferencia o depósito</h2>
                      </div>

                      <div className="ocf-fields">
                        <RenderIf isTrue={!!paymentInfo.bank_name}>
                          <div className="ocf-field">
                            <span className="ocf-field-label">Banco</span>
                            <span className="ocf-field-value">{paymentInfo.bank_name}</span>
                          </div>
                        </RenderIf>

                        <RenderIf isTrue={!!paymentInfo.account_type}>
                          <div className="ocf-field">
                            <span className="ocf-field-label">Tipo de cuenta</span>
                            <span className="ocf-field-value">{paymentInfo.account_type}</span>
                          </div>
                        </RenderIf>

                        <RenderIf isTrue={!!paymentInfo.account_number}>
                          <div className="ocf-field">
                            <span className="ocf-field-label">Número de cuenta</span>
                            <span className="ocf-field-value ocf-mono">{paymentInfo.account_number}</span>
                          </div>
                        </RenderIf>

                        <RenderIf isTrue={!!paymentInfo.account_holder}>
                          <div className="ocf-field">
                            <span className="ocf-field-label">Titular</span>
                            <span className="ocf-field-value">{paymentInfo.account_holder}</span>
                          </div>
                        </RenderIf>
                      </div>

                      <p className="ocf-note">
                        Realiza tu transferencia o depósito y conserva el comprobante para su validación.
                      </p>
                    </section>
                  </RenderIf>

                  {orderData?.is_scheduled && (
                    <section className="ocf-card ocf-info">
                      <RenderIf isTrue={orderData.order_type === "delivery"}>
                        <div className="ocf-info-head">
                          <span className="ocf-info-icon" aria-hidden="true"><i className="uil uil-schedule"></i></span>
                          <h2 className="ocf-h2">Delivery programado</h2>
                        </div>
                      </RenderIf>
                      <RenderIf isTrue={orderData.order_type === "pickngo"}>
                        <div className="ocf-info-head">
                          <span className="ocf-info-icon" aria-hidden="true"><i className="uil uil-schedule"></i></span>
                          <h2 className="ocf-h2">Retiro programado (Pick & Go)</h2>
                        </div>
                      </RenderIf>

                      <div className="ocf-fields">
                        <div className="ocf-field">
                          <span className="ocf-field-label">Hora programada</span>
                          <span className="ocf-field-value">
                            {FormatDateTime(orderData.scheduled_for, orderData.scheduled_timezone)}
                          </span>
                        </div>

                        {orderData?.scheduled_window?.start && orderData?.scheduled_window?.end && (
                          <div className="ocf-field">
                            <span className="ocf-field-label">Ventana de recogida</span>
                            <span className="ocf-field-value">
                              {FormatDateTime(orderData.scheduled_window.start, orderData.scheduled_timezone)}{" "}
                              — {FormatDateTime(orderData.scheduled_window.end, orderData.scheduled_timezone)}
                            </span>
                          </div>
                        )}

                        {orderData?.scheduled_timezone && (
                          <div className="ocf-field">
                            <span className="ocf-field-label">Zona horaria</span>
                            <span className="ocf-field-value">{orderData.scheduled_timezone}</span>
                          </div>
                        )}
                      </div>

                      <p className="ocf-note">
                        Te avisaremos en esta página cuando tu pedido esté <em>listo para retirar</em>. Muestra el número de orden en caja.
                      </p>
                    </section>
                  )}

                  {/* ── CONTENIDO: recibo + estado ── */}
                  <div className="ocf-grid">

                    {/* Recibo */}
                    <section className="ocf-card ocf-receipt" aria-labelledby="ocf-receipt-title">
                      <div className="ocf-receipt-head">
                        <div className="ocf-receipt-id">
                          <h2 className="ocf-business" id="ocf-receipt-title">{businessData.name}</h2>
                          <p className="ocf-order-code">Orden <strong>#{orderData.transaction_code}</strong></p>
                        </div>

                        {/* Notificador: el número que se muestra en caja */}
                        <div className="ocf-locator">
                          <span className="ocf-locator-label">Notificador</span>
                          <span className="ocf-locator-value"># {orderData.locator}</span>
                        </div>
                      </div>

                      <div className="ocf-items-head">
                        <span>Productos</span>
                        <span>Precio</span>
                      </div>

                      <div className="ocf-items">
                        {/* Item cards */}
                        {orderItems()}
                      </div>

                      {orderTotals()}

                      <div className="ocf-receipt-actions">
                        {orderData.voucher_response !== "0" && orderData.voucher_response !== 0 ? <>
                          <button type="button" className="ocf-btn ocf-btn-ghost" onClick={() => (handleViewCoucher())}>
                            <i className="uil uil-receipt-alt" aria-hidden="true"></i> Voucher de transacción
                          </button>
                        </> : <></>}

                        <button type="button" className="ocf-btn ocf-btn-quiet" onClick={() => (navigate(`/home`))}>
                          <i className="uil uil-estate" aria-hidden="true"></i> Volver al inicio
                        </button>
                      </div>
                    </section>

                    {/* Orders Status*/}
                    <section className="ocf-card ocf-status" aria-labelledby="ocf-status-title">
                      <h2 className="ocf-h2" id="ocf-status-title">Estado de la orden</h2>
                      <ul className="ocf-timeline">
                        {orderHistory()}
                      </ul>
                    </section>
                  </div>
                </div>
              </div>

              {/* ── DOCK INFERIOR (solo móvil / tablet) ── */}
              <div className="ocf-dock" role="region" aria-label="Resumen de la orden">
                <button type="button" className="ocf-dock-btn" onClick={() => setOcfSheet("status")} aria-haspopup="dialog">
                  <span className="ocf-dock-icon" aria-hidden="true"><i className="uil uil-clock-three"></i></span>
                  <span className="ocf-dock-text">
                    <span className="ocf-dock-label">Estado</span>
                    <span className="ocf-dock-value">{ocfLastStatus || "Ver estado"}</span>
                  </span>
                </button>

                <button type="button" className="ocf-dock-btn ocf-dock-btn-total" onClick={() => setOcfSheet("total")} aria-haspopup="dialog">
                  <span className="ocf-dock-text">
                    <span className="ocf-dock-label">Total · {cardsItems.length} producto{cardsItems.length === 1 ? "" : "s"}</span>
                    <span className="ocf-dock-value ocf-dock-amount">${typeof orderData.total === 'number' ? orderData.total.toFixed(2) : orderData.total}</span>
                  </span>
                  <i className="uil uil-angle-up ocf-dock-chev" aria-hidden="true"></i>
                </button>
              </div>

              {/* ── HOJA INFERIOR (popup del dock) ── */}
              {ocfSheet ? createPortal(
                <div className="ocf-sheet-root">
                  <button type="button" className="ocf-sheet-backdrop" aria-label="Cerrar" onClick={() => setOcfSheet(null)} />

                  <div className="ocf-sheet" role="dialog" aria-modal="true" aria-labelledby="ocf-sheet-title">
                    {/* Header fijo */}
                    <div className="ocf-sheet-head">
                      <span className="ocf-sheet-grabber" aria-hidden="true" />
                      <div className="ocf-sheet-titles">
                        <h2 className="ocf-sheet-title" id="ocf-sheet-title">
                          {ocfSheet === "status" ? "Estado de la orden" : "Detalle del pago"}
                        </h2>
                        <p className="ocf-sheet-sub">
                          Orden #{orderData.transaction_code} · Notificador # {orderData.locator}
                        </p>
                      </div>
                      <button type="button" className="ocf-sheet-close" onClick={() => setOcfSheet(null)} aria-label="Cerrar">
                        <i className="uil uil-times" aria-hidden="true"></i>
                      </button>
                    </div>

                    {/* Body con scroll */}
                    <div className="ocf-sheet-body">
                      {ocfSheet === "status" ? (
                        <ul className="ocf-timeline">
                          {orderHistory()}
                        </ul>
                      ) : (
                        <>

                          {orderTotals()}
                        </>
                      )}
                    </div>

                    {/* Footer estático con los botones */}
                    <div className="ocf-sheet-foot">
                      {ocfSheet === "status" ? (
                        <RenderIf isTrue={orderData.delivery && orderData.delivery.platform !== "smartpay" && orderData.delivery.order_id && orderData.delivery.order_id !== ""}>
                          <button type="button" className="ocf-btn ocf-btn-ghost" onClick={() => { setOcfSheet(null); openTracking(); }}>
                            <i className="uil uil-truck" aria-hidden="true"></i> Seguimiento de delivery
                          </button>
                        </RenderIf>
                      ) : (
                        orderData.voucher_response !== "0" && orderData.voucher_response !== 0 ? (
                          <button type="button" className="ocf-btn ocf-btn-ghost" onClick={() => { setOcfSheet(null); handleViewCoucher(); }}>
                            <i className="uil uil-receipt-alt" aria-hidden="true"></i> Voucher de transacción
                          </button>
                        ) : null
                      )}
                      <button type="button" className="ocf-btn ocf-btn-primary" onClick={() => setOcfSheet(null)}>
                        Cerrar
                      </button>
                    </div>
                  </div>
                </div>,
                document.body
              ) : null}

              {/* Modal tracking */}
              <Modal show={trackOpen} onHide={closeTracking} size="lg" centered>
                <Modal.Header closeButton>
                  <Modal.Title>Seguimiento de delivery</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <p>Realiza el seguimiento de tu entrega en tiempo real.</p>
                  {orderData?.delivery?.platform === 'tookan' && (
                    <div className="mt-3">
                      <a href={tookanTrackingLink} target="_blank" rel="noreferrer" className="btn btn-outline-secondary btn-sm">
                        Ver enlace de tracking
                      </a>
                    </div>
                  )}
                  <hr />

                  {/* Estado actual (derivado del último evento del log) */}
                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-2">
                      <span className="fw-bold">Estado actual:</span>
                      {trackLoading ? (
                        <span className="small text-muted">Cargando...</span>
                      ) : (
                        <span className={`badge ${latestKey === 'completed'
                          ? 'bg-success'
                          : latestKey === 'cancelled'
                            ? 'bg-danger'
                            : 'bg-secondary'}`}>
                          {latestEvent?.label || '—'}
                        </span>
                      )}
                    </div>
                    <small className="text-muted">
                      {latestEvent?.at ? `Actualizado: ${FormatDateTime(latestEvent.at)}` : ''}
                    </small>
                  </div>

                  {/* Barra de progreso */}
                  <div className="mb-4">
                    <div className="d-flex justify-content-between" style={{ fontSize: '.9rem' }}>
                      {FLOW.map((step, i) => {
                        const active = currentStepIndex >= i;
                        return (
                          <div key={step} className="text-center flex-fill">
                            <div
                              className={`rounded-circle mx-auto mb-2 ${active ? 'bg-success' : 'bg-light'}`}
                              style={{ width: 16, height: 16 }}
                              title={step}
                            />
                            <div className={`${active ? 'fw-bold' : 'text-muted'}`}>
                              {step === 'placed' ? 'Placed'
                                : step === 'assigned' ? 'Assigned'
                                  : step === 'arrived' ? 'Arrived'
                                    : step === 'started' ? 'Picked Up'
                                      : 'Completed'}
                            </div>
                            {i < FLOW.length - 1 && (
                              <div
                                className={`mx-auto my-2 ${currentStepIndex > i ? 'bg-success' : 'bg-light'}`}
                                style={{ height: 4, width: '100%', borderRadius: 999 }}
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Historial */}
                  <div className="mt-3">
                    <h6 className="mb-3">Historial</h6>
                    {trackLog?.length ? (
                      <ul className="list-group">
                        {trackLog.map((e) => (
                          <li className="list-group-item d-flex justify-content-between align-items-start" key={e.id}>
                            <div>
                              <div className="fw-bold">{e.label}</div>
                              <div className="small text-muted">{e.description}</div>
                            </div>
                            <div className="text-end small">{e.at ? FormatDateTime(e.at) : ''}</div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div className="text-muted">{trackLoading ? 'Cargando eventos...' : 'Sin eventos registrados.'}</div>
                    )}
                  </div>
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="secondary" onClick={closeTracking}>Cerrar</Button>
                  <Button variant="outline-primary" onClick={fetchDeliveryLogOnly}>Refrescar</Button>
                </Modal.Footer>
              </Modal>

              {/* Modal voucher */}
              <Modal
                show={modalShowVoucher}
                onHide={() => setmodalShowVoucher(false)}
                size='lg'
                centered>
                <Modal.Header>
                  Voucher de transaccion: #{orderData.transaction_code}
                </Modal.Header>
                <Modal.Body>
                  <div className='d-flex alight-item-center justify-content-center'>
                    <div>
                      <pre>{formatVoucher}</pre>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={() => (setmodalShowVoucher(false))}>Cerrar</Button>
                </Modal.Footer>
              </Modal></> : <>
              <div className="ocf-login-back">
                <button
                  type="button"
                  className="ocf-btn ocf-btn-ghost"
                  onClick={() => setLoginRequired(false)}
                >
                  <i className="uil uil-arrow-left" aria-hidden="true"></i> Volver a la orden
                </button>
              </div>
              <LoginUser modalUser={modalUser} setModalUser={setModalUser} shoppingCart={true} closedModalLoginAndRegister={closedModalLoginAndRegister} />

            </>}
          </div>

        </>)


      }



    </>
  )
}

export default OrderConfirmation
